import { Tv, Award, Users, Clapperboard } from "lucide-react";
import Reveal from "./Reveal";

const CHIPS = [
  { icon: Award, label: "Network-Scouted" },
  { icon: Users, label: "Executive Callbacks" },
  { icon: Clapperboard, label: "Producer Rounds" },
];

export default function VoiceCard() {
  return (
    <section id="voice" className="relative py-24 lg:py-32" data-testid="voice-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-16">
        <Reveal>
          <div className="rounded-3xl p-px bg-gradient-to-r from-hpink via-horange to-hblue glow-pink">
            <div className="relative rounded-3xl bg-surface overflow-hidden grid lg:grid-cols-[1fr_auto] gap-10 p-8 sm:p-12 lg:p-16">
              <div className="pointer-events-none absolute -top-24 -right-24 w-[420px] h-[420px] rounded-full bg-hpink/15 blur-[120px]" />
              <div>
                <div className="flex items-center gap-3 mb-6">
                  <span className="font-mono text-xs tracking-[0.3em] text-hpink">01</span>
                  <span className="h-px w-12 bg-gradient-to-r from-hpink to-horange" />
                  <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-hdim flex items-center gap-2">
                    <Tv size={13} /> Television & National Auditions
                  </span>
                </div>

                <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight leading-[0.92]">
                  NBC&rsquo;s <span className="text-stroke">The Voice</span>
                </h2>
                <p className="mt-4 font-mono text-xs sm:text-sm tracking-[0.2em] text-horange uppercase">
                  Season 1 (2011) — Invited Auditionee &amp; Executive Callback Finalist
                </p>
                <p className="mt-6 max-w-2xl text-hmut text-base sm:text-lg leading-relaxed">
                  Scouted and selected by network casting directors for the inaugural season;
                  advanced through executive callbacks and producer rounds.
                </p>

                <div className="mt-8 flex flex-wrap gap-3">
                  {CHIPS.map((c) => (
                    <span
                      key={c.label}
                      className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-2 text-xs font-semibold text-white"
                      data-testid="voice-credit-chip"
                    >
                      <c.icon size={13} className="text-hblue" /> {c.label}
                    </span>
                  ))}
                </div>
              </div>

              <div className="flex items-center justify-center">
                <div className="relative w-44 h-44 lg:w-56 lg:h-56 rounded-full border border-hpink/30 flex items-center justify-center floaty-slow">
                  <div className="absolute inset-3 rounded-full border border-horange/30" />
                  <div className="absolute inset-6 rounded-full border border-hblue/30" />
                  <span className="font-display font-black text-6xl lg:text-7xl text-stroke tracking-tighter">
                    S1
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
